import DM from 'DM';
import {getCookie} from "../../redirect/utils/cookie";

const KEY = 'DM-3AAAD55C0C-4B5-53D';

export default class WPPIxelTracker {
    constructor() {
        this.name = 'wppixel';
    }

    dispatch(event, payload) {
        if (typeof this[event] === 'function') {
            this.loadScript()
                .then((wph) => this[event](wph, payload))
                .catch(DM.Log)
        }
    }

    loadScript() {
        return new Promise((resolve, reject) => {
            try {
                const trackerName = 'wph';

                if (typeof window[trackerName] === 'function') {
                    resolve(window[trackerName]);
                } else {
                    const uid = DM.Config.userId;
                    const em = DM.Config.userWpHash;
                    const ltid = getCookie('domodiCookies');
                    const trackerObjectName = 'WphTrackObject';
                    const script = document.getElementsByTagName('script')[0];
                    const lib = document.createElement('script');

                    window[trackerObjectName] = [trackerName];
                    window[trackerName] = (...args) => window[trackerName].queue.push(args);
                    window[trackerName].queue = [];
                    window[trackerName].l = 1 * new Date();

                    lib.async = true;
                    lib.src = 'https://pixel.wp.pl/w/' +
                        KEY +
                        '/tr.js';
                    //lib.src = 'https://pixel.domodi.pro/s/tr.js';
                    script.parentNode.insertBefore(lib, script);

                    window[trackerName]('init', KEY, {
                        ...(uid && { uid }),
                        ...(em && { em }),
                        ...(ltid && { ltid }),
                        blr: true,
                        bts: true
                    });

                    resolve(window[trackerName]);
                }
            } catch (error) {
                reject(error);
            }
        })
    }

    homeView(tracker) {
        tracker('track', 'ViewContent', {
            content_name: 'View'
        });
    }

    productsView(tracker, { categoryName, products, categoryId }) {
        tracker('track', 'ViewContent', {
            content_name: 'ProductList',
            name: categoryName,
            content_category_id: categoryId ? categoryId.toString() : '',
            contents: products.slice(0, 10).map(({ productId, productName, price }) => ({
                id: productId,
                name: productName,
                price: price,
                category_name: categoryName
            }))
        });
    }

    productLightboxView(tracker, { categoryName, productName, productId, price, isActive }) {
        tracker('track', 'ViewContent', {
            content_name: 'ViewProduct',
            contents: [
                {
                    id: productId.toString(),
                    name: productName,
                    category: categoryName,
                    price: price,
                    in_stock: isActive,
                }
            ]
        });
    }

    productDetailsView(tracker, { categoryName, productName, productId, price, isActive }) {
        tracker('track', 'ViewContent', {
            content_name: 'ViewProduct',
            contents: [
                {
                    id: productId.toString(),
                    name: productName,
                    category: categoryName,
                    price: price,
                    in_stock: isActive,
                }
            ]
        });
    }

    profileProductsView(tracker, { name, products }) {
        tracker('track', 'ViewContent', {
            content_type: 'category',
            name,
            contents: products.map(({ productId, productName, price, categoryName, isNotActive }) => ({
                id: productId,
                name: productName,
                price: price,
                category_name: categoryName,
                in_stock: !isNotActive
            }))
        });
    }

    trendDetailsView(tracker, { title, products }) {
        tracker('track', 'ViewContent', {
            content_type: 'article',
            name: title,
            contents: products.map(({ productId, name, price, category_name }) => ({
                id: productId,
                name,
                price,
                category_name
            }))
        });
    }

    landingPageView(tracker, { name }) {
        tracker('track', 'ViewContent', {
            content_type: 'category',
            name
        });
    }

    search(tracker, { value }) {
        tracker('track', 'CustomEvent', {
            content_type: 'search',
            name: value
        });
    }
}
